import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.html',
  styleUrl: './pagination.scss',
})
export class Pagination {
  @Input() currentPage = 1;
  @Input() pageSize = 10;
  @Input() totalItems = 0;
  @Input() disabled = false;
  @Output() pageChange = new EventEmitter<number>();

  startPage = 1;
  endPage = 1;

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.totalItems / this.pageSize));
  }

  onPageChange(page: number): void {
    if (this.disabled) return;
    if (page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];

    if (this.totalPages <= 5) {
      for (let i = 2; i < this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    if (this.currentPage <= 3) {
      this.startPage = 2;
      this.endPage = 4;
    } else if (this.currentPage >= this.totalPages - 2) {
      this.startPage = this.totalPages - 3;
      this.endPage = this.totalPages - 1;
    } else {
      this.startPage = this.currentPage - 1;
      this.endPage = this.currentPage + 1;
    }

    for (let i = this.startPage; i <= this.endPage; i++) {
      if (i !== 1 && i !== this.totalPages) {
        pages.push(i);
      }
    }

    return pages;
  }
}
